export default __webpack_public_path__ + "static/media/cypher_new.9de3cc74.png";